"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomFonts = function CustomFonts() {
  return _react["default"].createElement(_core.Global, {
    styles: {
      '@font-face': {
        fontFamily: 'Comicrazy',
        src: "url('https://media.versoapp.com/Fonts/CCComicrazy-Roman.woff2') format(\"woff2\"),\n        url('https://media.versoapp.com/Fonts/CCComicrazy-Roman.woff') format(\"woff\")"
      }
    }
  });
};

var _default = CustomFonts;
exports["default"] = _default;